module.exports = __webpack_public_path__ + "media/images/sanitary-img-1-79072609b67b9c32da16c658b687a35f.jpg";